import { render, staticRenderFns } from "./RefundsPaymentsList.vue?vue&type=template&id=61458738&"
import script from "./RefundsPaymentsList.vue?vue&type=script&lang=js&"
export * from "./RefundsPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports